/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { LatenessPeriod } from '../models/LatenessPeriod';
import type { LatenessPeriodDto } from '../models/LatenessPeriodDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class LatenessPeriodControllerService {
  /**
   * findAll
   * @returns LatenessPeriod OK
   * @throws ApiError
   */
  public static findAllUsingGet1(): CancelablePromise<Array<LatenessPeriod>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/lateness-period',
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * create
   * @returns LatenessPeriod OK
   * @returns any Created
   * @throws ApiError
   */
  public static createUsingPost4({
    latenessPeriodDto,
  }: {
    /**
     * latenessPeriodDto
     */
    latenessPeriodDto: LatenessPeriodDto;
  }): CancelablePromise<LatenessPeriod | any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/lateness-period',
      body: latenessPeriodDto,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * delete
   * @returns any OK
   * @throws ApiError
   */
  public static deleteUsingDelete4({
    id,
  }: {
    /**
     * id
     */
    id: string;
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/lateness-period/{id}',
      path: {
        id: id,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
      },
    });
  }
}
